import React from 'react';
import CreateQuoteRadioButton from './CreateQuoteRadioButton';

const QuoteFormat = ({ quoteFormat = {}, value = false, onClick }) => {
    /**
     * click event handler for radio button
     */
    const handleClick = () => {
        if (typeof onClick === 'function') {
            onClick(quoteFormat.id);
        } else {
            // eslint-disable-next-line no-console
            console.warn(`type of onClick is ${typeof onClick}`);
        }
    };

    return (
        <CreateQuoteRadioButton
            id={`quoteFormat${quoteFormat.name}`}
            title={quoteFormat.name}
            value={value}
            onClick={handleClick}
        />
    );
};

export default QuoteFormat;
